function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function() {
    var self = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { fetchRuntimeConfig, getRuntimeQuery } from "../config";
import * as constant from "../constants";
import { loadScript, isSSR, teaReport, initTea } from "./util";
let loadOnce = false;
let bannerInstance;
let currentLocale;
let pendingDisabled = false;
let pendingDisabledAccessKey = "";
const BANNER_CONFIG_ID = "tiktok-cookie-banner-config";
const optionalConfigs = [
  "enableTea",
  "theme",
  "appId",
  "apiDomain"
];
let consentApiDomain = "";
let customTheme = [];
function loadCookieBanner() {
  return _loadCookieBanner.apply(this, arguments);
}
function _loadCookieBanner() {
  _loadCookieBanner = _async_to_generator(function* (options = {}) {
    if (loadOnce || isSSR()) {
      return;
    }
    const existingBannerInstance = document.getElementsByTagName("tiktok-cookie-banner");
    if (existingBannerInstance === null || existingBannerInstance === void 0 ? void 0 : existingBannerInstance.length) {
      return;
    }
    loadOnce = true;
    const { locale = getRuntimeQuery().locale, enableTea = constant.DEFAULT_ENABLE_TEA } = options;
    if (options.consentApiDomain) {
      consentApiDomain = options.consentApiDomain;
    }
    if (options.customTheme) {
      customTheme = options.customTheme;
    }
    const fetchConfig = {};
    for (const configKey of optionalConfigs) {
      const configValue = options[configKey];
      if (typeof configValue !== "undefined") {
        Reflect.set(fetchConfig, configKey, configValue);
      }
    }
    if (locale) {
      currentLocale = locale;
      Reflect.set(fetchConfig, "locale", locale);
    }
    try {
      var _navigationList_cookieBanner;
      const navigationList = yield fetchRuntimeConfig(fetchConfig);
      if (!navigationList) {
        return;
      }
      if (enableTea) {
        initTea(navigationList === null || navigationList === void 0 ? void 0 : navigationList.tea);
      }
      let userConfigEle = document.getElementById(BANNER_CONFIG_ID);
      if (!userConfigEle) {
        userConfigEle = document.createElement("script");
        userConfigEle.id = BANNER_CONFIG_ID;
        userConfigEle.setAttribute("type", "application/json");
        document.body.appendChild(userConfigEle);
      }
      userConfigEle.textContent = JSON.stringify(_object_spread_props(_object_spread({}, navigationList), {
        consentApiDomain,
        customTheme
      }));
      const cookieBannerResource = navigationList === null || navigationList === void 0 ? void 0 : (_navigationList_cookieBanner = navigationList.cookieBanner) === null || _navigationList_cookieBanner === void 0 ? void 0 : _navigationList_cookieBanner.resource;
      if (!cookieBannerResource) {
        return;
      }
      if (bannerInstance) {
        return;
      }
      const { baseUrl, esm } = cookieBannerResource;
      loadScript(`${baseUrl}${esm}`);
      bannerInstance = document.createElement("tiktok-cookie-banner");
      bannerInstance.setAttribute("locale", currentLocale);
      bannerInstance.setAttribute("user-config-ele-id", BANNER_CONFIG_ID);
      bannerInstance.setAttribute("disabled", `${pendingDisabled}`);
      bannerInstance.setAttribute("disabled-access-key", `${pendingDisabledAccessKey}`);
      bannerInstance.addEventListener("bannerEvents", (ev) => {
        const { detail } = ev;
        if (!detail || typeof detail.type !== "string") {
          return;
        }
        let { type, payload } = detail;
        if (!Array.isArray(payload)) {
          payload = [
            payload
          ];
        }
        const eventCallbackName = `on${type.replace(/^\w/, (match) => match.toUpperCase())}`;
        if (typeof options[eventCallbackName] === "function") {
          options[eventCallbackName](...payload);
        }
      });
      document.body.appendChild(bannerInstance);
    } catch (e) {
      console.error(e);
    }
  });
  return _loadCookieBanner.apply(this, arguments);
}
function updateBannerLocale(locale) {
  return _updateBannerLocale.apply(this, arguments);
}
function _updateBannerLocale() {
  _updateBannerLocale = _async_to_generator(function* (locale) {
    try {
      if (!loadOnce) {
        return;
      }
      currentLocale = locale;
      const navigationList = yield fetchRuntimeConfig({
        locale
      });
      if (!navigationList || locale !== currentLocale) {
        return;
      }
      let userConfigEle = document.getElementById(BANNER_CONFIG_ID);
      if (!userConfigEle) {
        userConfigEle = document.createElement("script");
        userConfigEle.id = BANNER_CONFIG_ID;
        userConfigEle.setAttribute("type", "application/json");
        document.body.appendChild(userConfigEle);
      }
      userConfigEle.textContent = JSON.stringify(_object_spread_props(_object_spread({}, navigationList), {
        consentApiDomain,
        customTheme
      }));
      if (bannerInstance) {
        bannerInstance.setAttribute("locale", locale);
      }
    } catch (e) {
      console.error(e);
    }
  });
  return _updateBannerLocale.apply(this, arguments);
}
function setDisabled(disabled, disabledAccessKey) {
  teaReport("cookie_banner_set_disabled", {
    disabled: disabled ? 1 : 0
  });
  pendingDisabled = disabled;
  pendingDisabledAccessKey = disabledAccessKey;
  if (bannerInstance) {
    bannerInstance.setAttribute("disabled", `${disabled}`);
    bannerInstance.setAttribute("disabled-access-key", `${disabledAccessKey}`);
  }
}
function getConsent(cb) {
  if (typeof cb !== "function") {
    return;
  }
  let bannerEle = bannerInstance;
  if (!bannerEle) {
    var _document_getElementsByTagName;
    bannerEle = (_document_getElementsByTagName = document.getElementsByTagName("tiktok-cookie-banner")) === null || _document_getElementsByTagName === void 0 ? void 0 : _document_getElementsByTagName[0];
  }
  if (bannerEle) {
    bannerEle.addEventListener("getConsent", (ev) => {
      const { detail } = ev;
      if (!detail) {
        return;
      }
      let { cookieConsent, consentOptions } = detail.payload || {};
      cb(cookieConsent, consentOptions);
    });
  }
}
export {
  getConsent,
  loadCookieBanner,
  setDisabled,
  updateBannerLocale
};
